import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fabricCanvas: null,
  canvasAsImage: null,
  imageloaded: false,
  uploadedImages: [],
  pendingDownload: false,
};

const fabricCanvasSlice = createSlice({
  name: "fabricCanvas",
  initialState,
  reducers: {
    setFabricCanvas: (state, action) => {
      state.fabricCanvas = action.payload;
    },
    setImageloaded: (state, action) => {
      state.imageloaded = action.payload;
    },
    addUploadedImages: (state, action) => {
      state.uploadedImages = [...action.payload, ...state.uploadedImages];
    },
    setPendingDownload: (state, action) => {
      state.pendingDownload = action.payload;
    },
  },
});

export const {
  setFabricCanvas,
  setImageloaded,
  addUploadedImages,
  setPendingDownload,
} = fabricCanvasSlice.actions;

export default fabricCanvasSlice.reducer;
